export function TimeIntervalIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 17C3.81308 17 0 13.187 0 8.5C0 3.813 3.81308 0 8.5 0C13.1869 0 17 3.813 17 8.5C17 13.187 13.1869 17 8.5 17ZM8.5 1.0625C4.39898 1.0625 1.0625 4.3989 1.0625 8.5C1.0625 12.6011 4.39898 15.9375 8.5 15.9375C12.601 15.9375 15.9375 12.6011 15.9375 8.5C15.9375 4.3989 12.601 1.0625 8.5 1.0625Z"
        fill={color}
      />
      <path
        d="M8.5 9.03105C8.20662 9.03105 7.96875 8.79326 7.96875 8.4998V3.42871C7.96875 3.13524 8.20662 2.89746 8.5 2.89746C8.79338 2.89746 9.03125 3.13524 9.03125 3.42871V8.4998C9.03125 8.79326 8.79338 9.03105 8.5 9.03105Z"
        fill={color}
      />
      <path
        d="M12.1222 12.6533C11.9863 12.6533 11.8502 12.6014 11.7466 12.4977L8.1244 8.87561C7.91688 8.66826 7.91688 8.33174 8.12431 8.12439C8.33183 7.91687 8.66827 7.91687 8.87562 8.12439L12.4978 11.7465C12.7053 11.9538 12.7053 12.2903 12.4979 12.4977C12.3941 12.6014 12.2581 12.6533 12.1222 12.6533Z"
        fill={color}
      />
    </svg>
  );
}
